var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import useResizeObserver from 'use-resize-observer';
import { useDebounce } from 'use-debounce';
export default (function (wait, leading) {
    if (leading === void 0) { leading = false; }
    var _a = __read(useState({ width: 0, height: 0 }), 2), size = _a[0], setSize = _a[1];
    var _b = __read(useDebounce(size, wait, { leading: leading }), 1), value = _b[0];
    var ref = useResizeObserver({
        onResize: function (e) {
            //@ts-ignore
            setSize(e);
        },
    }).ref;
    return __assign({ ref: ref }, value);
});
